import { format, formatDistanceToNowStrict, isToday, isYesterday } from "date-fns";

const numberFormat = new Intl.NumberFormat("en-IN");

export const formatNumber = (n) => numberFormat.format(Number(n || 0));

export function formatPrice(amount, currency = "INR") {
  if (amount === null || amount === undefined) return "Custom";
  if (Number(amount) === 0) return "Free";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency, maximumFractionDigits: 0 }).format(amount);
}

export function formatRelative(value) {
  if (!value) return "";
  const date = new Date(value);
  if (isToday(date)) return format(date, "HH:mm");
  if (isYesterday(date)) return "Yesterday";
  return formatDistanceToNowStrict(date, { addSuffix: true });
}

export const formatDate = (value) => (value ? format(new Date(value), "d MMM yyyy") : "");

export const formatDateTime = (value) => (value ? format(new Date(value), "d MMM, HH:mm") : "");

export function initials(name, email) {
  const source = (name || "").trim() || (email || "").split("@")[0] || "?";
  const parts = source.split(/[\s._-]+/).filter(Boolean);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || source[0].toUpperCase();
}
